import React from "react";

export default function ManufacturingStory() {
  return (
    <section className="py-20 bg-[var(--aerzen-silver)]/20 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl font-bold mb-6 text-center">
          How AERZEN AIR™ Is Built
        </h2>

        <p className="text-gray-700 max-w-3xl mx-auto text-center mb-12">
          Every AERZEN AIR™ purifier goes through a controlled process —
          from component sourcing to final inspection — ensuring
          reliability in India’s toughest air conditions.
        </p>

        <div className="grid md:grid-cols-3 gap-8 text-sm">
          <div className="bg-white p-6 rounded-xl shadow">
            <strong>1. Component Selection</strong>
            <p className="mt-2 text-gray-600">
              Motors, sensors, and filters are selected from globally
              proven suppliers with performance validation.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow">
            <strong>2. Assembly & Testing</strong>
            <p className="mt-2 text-gray-600">
              Each unit undergoes airflow, noise, and electrical safety
              checks before packaging.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow">
            <strong>3. Final Quality Audit</strong>
            <p className="mt-2 text-gray-600">
              Batch-level inspections ensure consistency before shipment
              to Early Access customers.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
